import React, { useEffect } from 'react';
import { Icon } from '@wegroup/design-system';
import OfferAction from './OfferAction';
import { useTranslation } from 'react-i18next';
import useSelectedQuotesStore from '../../../store/zustand/selectedQuotes';
import { SelectedQuote } from '../../../types/storeTypes';

interface Props {
  selectedQuote: SelectedQuote;
}

const OfferSelectQuoteAction: React.FC<Props> = ({ selectedQuote }) => {
  const { id: offerId } = selectedQuote;
  const { t } = useTranslation();
  const isSelected = useSelectedQuotesStore((state) =>
    state.selectedQuotes.some(({ id }) => id === offerId),
  );

  const addQuoteToSelection = useSelectedQuotesStore((state) => state.add);
  const removeQuoteToSelection = useSelectedQuotesStore(
    (state) => state.remove,
  );

  const handleClick = () => {
    if (isSelected) {
      removeQuoteToSelection(offerId!);
    } else {
      addQuoteToSelection(selectedQuote);
    }
  };

  useEffect(() => {
    /** Initially add the quote to the selection if it's not already selected */
    if (!isSelected && offerId) {
      addQuoteToSelection(selectedQuote);
    }
  }, [offerId]);

  return (
    <OfferAction
      icon={
        <Icon
          name={
            isSelected ? 'GeneralActionsCloseOrRemove' : 'GeneralActionsAdd'
          }
        />
      }
      isPrimary
      onClick={handleClick}
      isDisabled={!offerId}
    >
      {isSelected ? t('DESELECT') : t('SELECT-OFFER')}
    </OfferAction>
  );
};

export default OfferSelectQuoteAction;
